/* eslint-disable no-unused-vars */
import appConfig from "../../../../app-config";
import ApiService from "../../api.service";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const RoamBinMovementsService = {
  async getByBarCode(barcode) {
    const requestScreenData = {
      url: `api/AlmondcoBinBarcodeVerify(Barcode='${barcode}')`
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async saveNew(payload) {
    var url = "api/Save_AlmondcoBinMovement";

    return await ApiService.post(url, payload);
  },
};

export { RoamBinMovementsService };
